module.exports = __webpack_public_path__ + "static/media/cn.c1b7e224.svg";